import { useToast } from '@melio/penny';
import { usePayment } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';
import { Buffer } from 'buffer';
import { saveAs } from 'file-saver';
import { useEffect, useRef } from 'react';

export const useDownloadPaymentConfirmation = () => {
  const paymentConfirmationIframe = useRef<HTMLIFrameElement>(null);
  const paymentConfirmationIframeURL = useRef<string>('');
  const { downloadPaymentConfirmation } = usePayment();
  const toast = useToast();
  const { formatMessage } = useMelioIntl();

  useEffect(
    () => () => {
      if (paymentConfirmationIframe.current) {
        document.body.removeChild(paymentConfirmationIframe.current);
        URL.revokeObjectURL(paymentConfirmationIframeURL.current);
      }
    },
    []
  );

  const download = async (paymentId: string) => {
    try {
      const res = await downloadPaymentConfirmation(paymentId);
      const blob = new Blob([Buffer.from(res.data.data.base64, 'base64')], { type: 'application/pdf' });

      const fileName = `Melio-Receipt-${paymentId}.pdf`;
      saveAs(blob, fileName);
    } catch (error) {
      toast({
        type: 'error',
        title: formatMessage(
          'activities.paymentScheduledSuccessfully.screens.paymentScheduled.paymentConfirmation.download.error'
        ),
        id: 'edit-vendor-success',
      });
    }
  };

  const print = async (paymentId: string) => {
    try {
      const res = await downloadPaymentConfirmation(paymentId);
      const blob = new Blob([Buffer.from(res.data.data.base64, 'base64')], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = url;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        iframe.contentWindow?.print();
      };

      (paymentConfirmationIframe as React.MutableRefObject<HTMLIFrameElement | null>).current = iframe;
      paymentConfirmationIframeURL.current = url;
    } catch (error) {
      toast({
        type: 'error',
        title: formatMessage(
          'activities.paymentScheduledSuccessfully.screens.paymentScheduled.paymentConfirmation.print.error'
        ),
        id: 'edit-vendor-success',
      });
    }
  };

  return { download, print };
};
